import { colors } from 'syngenta-digital-cropwise-react-ui-kit';
import { EnsoPhase, OniResponse } from 'base/types/FieldConditions';
import elNinoIcon from 'assets/icons/conditions-el-nino.svg';
import laNinaIcon from 'assets/icons/conditions-la-nina.svg';
import neutralIcon from 'assets/icons/conditions-neutral.svg';

export const phaseLabels: Record<EnsoPhase, string> = {
  el_nino: 'El Niño',
  la_nina: 'La Niña',
  neutral: 'Neutral',
  unknown: 'Unknown',
};

// Figma's ENSO fills are distinct from the installed UI kit's standard palette.
export const phaseColors: Record<EnsoPhase, string> = {
  el_nino: '#c9e9f6',
  la_nina: '#ffe6d0',
  neutral: '#f5f5f5',
  unknown: colors.neutral00,
};

export const phaseIcons = {
  el_nino: elNinoIcon,
  la_nina: laNinaIcon,
  neutral: neutralIcon,
};

export type KnownEnsoPhase = Exclude<EnsoPhase, 'unknown'>;
export type EnsoLineTone = 'red' | 'blue' | 'green' | 'gray';

export const ensoLineColors: Record<EnsoLineTone, string> = {
  red: colors.red50,
  blue: colors.blue60,
  green: colors.green50,
  gray: colors.neutral50,
};

export interface EnsoLineStyle {
  tone: EnsoLineTone;
  color: string;
  dotted: boolean;
  expected: boolean;
}

function regionalLineTone(phase: KnownEnsoPhase, region: string | null): EnsoLineTone {
  if (phase === 'neutral') {
    return 'green';
  }
  if (region === 'south') {
    return phase === 'el_nino' ? 'blue' : 'red';
  }
  if (region === 'center_west_southeast' || region === 'north_northeast') {
    return phase === 'el_nino' ? 'red' : 'blue';
  }
  return 'gray';
}

export function getEnsoLineStyle(
  phase: KnownEnsoPhase,
  impact: OniResponse['impact']
): EnsoLineStyle {
  const expected = impact?.phase === phase && impact.basis !== null && impact.basis !== undefined;
  const tone = expected ? regionalLineTone(phase, impact.region) : 'gray';
  return {
    tone,
    color: ensoLineColors[tone],
    dotted: !expected && phase === 'la_nina',
    expected,
  };
}
